import { type MultiSelectOption } from '@knack/asterisk-react';

export const translationKeyPrefixVariantTwo = 'components.setup_wizard.version_1.9' as const;
export const translationKeyPrefixVerticalUI = 'components.setup_wizard.vertical_stack_ui' as const;
export const translationKeyPrefixHorizontalUI =
  'components.setup_wizard.horizontal_stack_ui' as const;

export const goalsVerticalStackUI: MultiSelectOption[] = [
  {
    label: 'Store & Organize Data',
    key: 'store_organize_data',
    value: 'Store & Organize Data',
    isDisabled: false,
    description: 'Database, records, CSV files'
  },
  {
    label: 'Collect Data from my Users',
    key: 'collect_data',
    value: 'Collect Data from my Users',
    isDisabled: false,
    description: 'Forms, checklists'
  },
  {
    label: 'Visualize my Data',
    key: 'visualize_my_data',
    value: 'Visualize my Data',
    isDisabled: false,
    description: 'Reports, charts, dashboards'
  },
  {
    label: 'Create Automations & Integrations',
    key: 'create_automations_integrations',
    value: 'Create Automations & Integrations',
    isDisabled: false,
    description: 'Triggers, actions'
  },
  {
    label: 'Build a Digital Process',
    key: 'build_digital_process',
    value: 'Build a Digital Process',
    isDisabled: false,
    description: 'Approvals, projects, cases'
  },
  {
    label: 'Customize Access for Groups',
    key: 'customize_access',
    value: 'Customize Access for Groups',
    isDisabled: false,
    description: 'Portals, permissions'
  }
];

export const goalsHorizontalStackUI: MultiSelectOption[] = [
  {
    label: 'Centralize & organize my data',
    key: 'centralize_organize_data',
    value: 'Centralize & organize my data',
    isDisabled: false,
    description: 'Databases to unify CSVs, spreadsheets, & data from other tools'
  },
  {
    label: 'Collect data from users',
    key: 'collect_data',
    value: 'Collect data from users',
    isDisabled: false,
    description: 'Forms, checklists, structured inputs'
  },
  {
    label: 'Visualize & report on data',
    key: 'visualize_report_data',
    value: 'Visualize & report on data',
    isDisabled: false,
    description: 'Dashboards, charts, reports'
  },
  {
    label: 'Build automations & integrations',
    key: 'build_automations_integrations',
    value: 'Build automations & integrations',
    isDisabled: false,
    description: 'Triggers, actions, rules, & notifications'
  },
  {
    label: 'Build operational processes',
    key: 'build_operational_processes',
    value: 'Build operational processes',
    isDisabled: false,
    description: 'Invoice management, projects & tasks, events, scheduling'
  },
  {
    label: 'Create user portals',
    key: 'create_user_portals',
    value: 'Create user portals',
    isDisabled: false,
    description: 'Secure access by custom role & permissions'
  }
];
